import { Link } from "react-router-dom";
import { CalendarPlus } from "lucide-react";
import { useApi } from "@/lib/api";
import { fmtDateTime, gcalLink } from "@/lib/crm";
import { TYPE_META } from "./TypePicker";

export const BookingAppointments = () => {
  const { data = [] } = useApi("/booking/appointments");
  return (
    <section className="bg-white border border-slate-200/80 rounded-xl p-6 space-y-3" data-testid="online-appointments">
      <h3 className="font-display font-semibold">Appuntamenti prenotati online</h3>
      {data.length === 0 && <p className="text-sm text-slate-500">Ancora nessuna prenotazione. Condividi il tuo link con i clienti!</p>}
      <div className="divide-y">
        {data.map((a) => (
          <div key={a.reminder_id} data-testid={`online-appt-${a.reminder_id}`} className="flex items-center justify-between gap-4 py-3 hover:bg-slate-50 -mx-2 px-2 rounded">
            <Link to={`/clienti/${a.client_id}`} className="min-w-0 flex-1">
              <p className="text-sm font-medium">{a.client_name} <span className="text-slate-400 font-normal">· {a.client_phone}</span></p>
              <p className="text-xs text-slate-500 truncate">{a.reason}</p>
            </Link>
            <div className="text-right shrink-0">
              <p className="text-sm font-mono">{fmtDateTime(a.due_at)}</p>
              <p className={`text-xs ${a.done ? "text-emerald-600" : "text-sky-700"}`}>{a.done ? "Completato" : TYPE_META[a.appointment_type]?.label}</p>
              {a.email_status && (
                <p data-testid={`online-appt-email-${a.reminder_id}`} className={`text-[11px] ${a.email_status.client === "inviata" ? "text-emerald-600" : "text-amber-600"}`}>
                  Email cliente: {a.email_status.client}
                </p>
              )}
              <a data-testid={`online-appt-gcal-${a.reminder_id}`} href={gcalLink(a)} target="_blank" rel="noreferrer"
                className="inline-flex items-center gap-1 text-[11px] text-sky-700 hover:underline mt-0.5">
                <CalendarPlus className="h-3 w-3" /> Google Calendar
              </a>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};
